'use strict';
import "core-js";
import 'whatwg-fetch';

var $ = require('jquery');
global.$ = $;

var Cookie = require('js-cookie');
var deviceState = require('./components/device-state');
import Vue from 'vue';
import {SearchField} from "./components/SearchField";

require('./jquery/toggleBox');
require('bootstrap/js/tooltip');

// We're not using $.ready here as the script will be loaded at the end of the page
(function initToggleBox() {
    $('.toggle-box').toggleBox();
    // $(document).trigger('togglebox-initialized')
})();

// Search in menu mobile
(function toggleHeaderForm() {
    var $button = $('.add-package-button');
    var button = document.getElementById('quick-pricing-button');

    $('.parcel-search')
        .each(function() {
            new Vue({
                components: {
                    SearchField
                },
                data: () => {
                    return {term: ''};
                },
                el: this,
                methods: {
                    submit() {
                        location.href = '/sledzenie-przesylki/status/' + encodeURIComponent(this.term)
                    }
                }
            });
        });

    $button.on('click', function() {
        quickPricing.$refs.toggler.toggle();

        var event = new Event('quick-pricing-form-opened');
        button.dispatchEvent(event);
    });
})();

// Toggle menu
(function initToggleMenu() {

    $('.footer-part > p.footer-part__menu-heading').on('click', function(event) {
        if (!deviceState.isMobileOrTablet) {
            return;
        }

        $(this).parent()
            // .closest('ul')
            .find('.footer-part__menu')
            .toggleClass('footer-part__menu--visible');
        return false;
    });
})();

// Init mobile menu
(function initMobileMenu() {
    var $body = $('body');
    var $headerMenu = $('.main__header__menu');
    var $userMenu = $('.menu__container');
    var BODY_OFFSET_CLASS = 'offset-right';
    var currentlyOpenMenu;

    // leave this reflow span as it's necessary to force chrome to properly compute width
    const reflowSpan = document.createElement('span');
    reflowSpan.id = 'reflow-span';

    var toggleMenu = function(menu) {
        if (!deviceState.isMobileOrTablet) {
            return;
        }
        if (currentlyOpenMenu && menu === currentlyOpenMenu) {
            $body.removeClass(BODY_OFFSET_CLASS);
            $body.removeAttr('data-offcanvas-menu');
            currentlyOpenMenu = undefined;
            $(reflowSpan).detach();
            return;
        }
        currentlyOpenMenu = menu;
        var $menuToShow = menu === 'user' ? $userMenu : $headerMenu;
        var $menuToHide = menu === 'user' ? $headerMenu : $userMenu;

        $body.addClass(BODY_OFFSET_CLASS);
        $body.attr('data-offcanvas-menu', menu);
        $menuToShow.attr('data-offcanvas', 'shown');
        $menuToHide.attr('data-offcanvas', '');
        setTimeout(() => {
            $body.append(reflowSpan);
        }, 510);
    };

    $('.mobile-menu-user').on('click', function(e) {
        // is clicking within menu container then ignore it
        if ($.contains($userMenu.get(0), e.target)) {
            return;
        }
        toggleMenu('user');
    });
    $('.mobile-menu').on('click', function() {
        toggleMenu('main');
    });
    $('.menu__close').on('click', function() {
        toggleMenu(currentlyOpenMenu);
    });
    $body.addClass('has-transitions');
})();

(function makeTooltips () {

    window.getBoundingClientRect = function() {
        return {
            top: 0,
            bottom: window.innerHeight,
            x: 0,
            y: 0,
            height: window.innerHeight,
            left: 0,
            right: window.innerWidth,
            width: window.innerWidth
        };
    };

    window.getClientRects = function() {
        return []
    };

    $('.info-tooltip[data-tip][title!=""]').tooltip({
        placement: 'auto top',
        html: true,
        container: '.tabs__panel',
    });

    $('.pallette-tip[title!=""]').tooltip({
        placement: 'auto top',
        html: true,
    });

    $('[data-tip][title!=""]').tooltip({
        placement: 'auto top',
        html: true,
    });
})();

(function() {
    var $toggle = $('.filter-box__toggle');
    var $filterBox = $('.filter-box');
    var COLLAPSED_CLASS = 'filter-box--collapsed';

    if($filterBox.hasClass(COLLAPSED_CLASS)) {
        $toggle.html('Pokaż filtry');
    }

    $toggle.on('click', function() {
        $toggle.html($filterBox.hasClass(COLLAPSED_CLASS) ? 'Ukryj filtry' : 'Pokaż filtry');
        $filterBox.toggleClass(COLLAPSED_CLASS);
    })
})();

(function() {
    $('body').on('click', '.modal__close-button', function() {
        $(this).closest('.modal')
            .removeClass('modal--active');
        document.querySelector('body').style.overflowY = 'unset';
    })

    function updateViewportHeight() {
      const viewportHeight = window.innerHeight;
      document.documentElement.style.setProperty('--vh', `${viewportHeight * 0.01}px`);
    }

    // Zareaguj na zmiany w VisualViewport (jeśli dostępne)
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateViewportHeight);
      window.visualViewport.addEventListener('scroll', updateViewportHeight);
    }

    // Fallback dla starszych przeglądarek
    window.addEventListener('resize', updateViewportHeight);

    // Inicjalizacja
    updateViewportHeight();

})();

function getCookiePolicy() {
    return Cookie.get('cookie_policy');
}

function setCookiePolicy() {
    Cookie.set('cookie_policy', true, {expires: 730});
}

(function cookiesPolicy() {

    if (getCookiePolicy() !== 'true') {
        $('#cookies_policy').removeClass('close');

        setTimeout(function() {
            $('#cookies_policy').addClass('close');
            setCookiePolicy();
        }, 30000);
    }

    $('#cookies-policy__close').click(function() {
        $('#cookies_policy').addClass('close');
        setCookiePolicy();
    });

    $('#cookies-policy__info').click(function() {
        setCookiePolicy();
    });

})();

import {Menu} from './components/CustomerBox/Menu';
import {Cart} from './components/CustomerBox/Cart';
(function() {
    new Vue({
        el: '#component_customer_box',
        components: {
            Menu,
            Cart
        },
        data() {
            return {}
        },
        mounted() {}

    })
})();

if (!location.pathname.includes('/zamowieni')) {
    sessionStorage.removeItem('start')
    localStorage.removeItem('DataTables_DataTables_Table_0_/zamowienia')
}